import { createContext } from 'react';

const CitasContext = createContext();

export default CitasContext;